export const backendUrl = 'https://chularat-api-dev.azurewebsites.net/'   //'https://chularat-api-dev.azurewebsites.net/'

export const allowFileExtensionsImage = '.jpg, .jpeg, .png'


export const goToSignInPage = (url: string | undefined, delay = 1000) => {
  setTimeout(() => {
    window.open(url, '_self')
  }, delay)
}

